const topbar = {
    docs: '文档',
    help: '帮助',
};
export default Object.freeze(topbar);
